import { render, staticRenderFns } from "./ContractPercentageYearConfig.vue?vue&type=template&id=30464d31"
import script from "./ContractPercentageYearConfig.vue?vue&type=script&lang=js"
export * from "./ContractPercentageYearConfig.vue?vue&type=script&lang=js"
import style0 from "./ContractPercentageYearConfig.vue?vue&type=style&index=0&id=30464d31&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports